import Tracking from 'lib/tracking';
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component(async (node) => {
  const {
    dropdownItem,
    dropdownItemLink,
    dropdownBannerVideo,
    navigationItem,
    dropdownCloseButton,
    navigationWrapper,
  } = choozy(node);
  const header = node.closest('header');

  const dropdownBannerVideos = [].concat(dropdownBannerVideo);

  const openDropdown = (event, { isMobile } = window.theme) => {
    const { target } = event;
    const dropdown = target.closest('[data-dropdown-item]');
    const dropdownContent = dropdown.querySelector('.header__navigation-dropdown');

    if (isMobile && event.type === 'click') {
      event.preventDefault();
      navigationWrapper.style.setProperty('height', `${dropdownContent.scrollHeight}px`);
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }

    if (!isMobile || event.type === 'click') {
      dropdown.setAttribute('open', '');
      header.setAttribute('open', '');
    }
  };

  const closeDropdown = (event, { isMobile } = window.theme) => {
    event.stopPropagation();

    const { target } = event;
    const dropdown = target.closest('[data-dropdown-item]');

    if (isMobile && event.type === 'click') {
      navigationWrapper.style.removeProperty('height');
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }

    if (!isMobile || event.type === 'click') {
      dropdown.removeAttribute('open');
      header.removeAttribute('open');
    }
  };

  const loadVideo = (video) => {
    const { sources: sourcesString } = video.dataset;
    const sources = JSON.parse(sourcesString);

    sources.forEach((source) => {
      video.insertAdjacentHTML(
        'beforeend',
        `<source src="${source}" type="video/${source.split(/[#?]/)[0].split('.').pop().trim()}">`,
      );
    });
  };

  const sendLinkDataLayer = (event) => {
    window.dataLayer?.push({
      event: 'navigation',
      eventCategory: 'Navigation',
      eventAction: Tracking.getLevel(parseInt(event.currentTarget.dataset.level, 10)),
      eventLabel: `${event.currentTarget.firstElementChild.textContent.trim()}_hover`,
    });
  };

  const saveNavigationStatement = (event, { isMobile } = window.theme) => {
    const { target } = event;
    const openedDropdownItem = dropdownItem.find((item) => item.hasAttribute('open'));
    const openedDropdownItemIndex = dropdownItem.indexOf(openedDropdownItem);

    if (openedDropdownItem && target.closest('.header__navigation-dropdown a') && isMobile) {
      sessionStorage.setItem('opened_nav_index', openedDropdownItemIndex);
    }
  };

  const loadNavigationStatement = ({ isMobile } = window.theme) => {
    const openedDropdownItemIndex = sessionStorage.getItem('opened_nav_index');

    if (openedDropdownItemIndex && isMobile) {
      const openedDropdownContent = dropdownItem[openedDropdownItemIndex].querySelector(
        '.header__navigation-dropdown',
      );

      navigationWrapper.style.setProperty('height', `${openedDropdownContent.scrollHeight}px`);
      dropdownItem[openedDropdownItemIndex].setAttribute('open', '');
      sessionStorage.removeItem('opened_nav_index');
    }
  };

  dropdownItemLink?.forEach((dropdownItemLinkElement) => {
    dropdownItemLinkElement.addEventListener('click', openDropdown);
  });

  dropdownItem?.forEach((dropdownItemElement) => {
    let isMouseover = false;

    dropdownItemElement.addEventListener('mouseenter', (event) => {
      isMouseover = true;

      setTimeout(() => {
        if (isMouseover) {
          openDropdown(event);
        }
      }, 150);
    });

    dropdownItemElement.addEventListener('mouseleave', (event) => {
      isMouseover = false;

      setTimeout(() => {
        if (isMouseover === false) {
          closeDropdown(event);
        }
      }, 150);
    });
  });

  navigationItem?.forEach((navigationItemElement) => {
    navigationItemElement.addEventListener('mouseenter', sendLinkDataLayer);
  });

  dropdownCloseButton?.forEach((dropdownCloseButtonElement) => {
    dropdownCloseButtonElement.addEventListener('click', closeDropdown);
  });

  node.addEventListener('click', saveNavigationStatement);

  if (dropdownBannerVideo) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          videoObserver.unobserve(entry.target);
        }
      });
    });

    dropdownBannerVideos?.forEach((dropdownBannerVideoElement) => {
      videoObserver.observe(dropdownBannerVideoElement);
    });
  }

  loadNavigationStatement();
});
